
// ==============================
// Tracking page
// ==============================

// Tracking-page FAQ answers (independent from Help Centre)
const trackerFaqContent = {
  orders_unfulfilled: `
    <p>Your order shows as “Fulfilled” once the courier has collected your gear from our warehouse. Orders placed later in the day may not be collected until the next working day. Check our Delivery information for more detail on processing times.</p>
  `,
  orders_change: `
    <p>If you want to swap items, <a href="https://esportsgear.uk/pages/contact?hc=orders&i=change_order" target="_blank">contact us</a> as soon as possible after placing your order. We can usually make changes before your gear has been picked and handed to the courier. Once you’ve had a shipping confirmation, we can’t amend it.</p>
  `,
  orders_cancel: `
    <p>You can <a href="https://esportsgear.uk/pages/contact?hc=orders&i=cancel_order&f=orders_cancel" target="_blank">request a cancellation</a> as long as the order hasn’t been collected from our warehouse or had its shipping confirmation issued. If the parcel is already on its way, the easiest option is to refuse the delivery or treat it as a change-of-mind return.</p>
  `,
  del_change_address: `
    <p>We can update the delivery address only before your order is packed and collected by the courier. Once it’s been handed over, we can’t guarantee any changes.</p>
    <p>If you need to change the address, <a href="https://esportsgear.uk/pages/contact?hc=delivery&i=change_address" target="_blank">contact us</a> as soon as possible with your order number and the correct details.</p>
  `,
  del_where: `
    <p>Once your order is marked “Shipped,” it’s with the courier.</p> 
    <p>Tracking usually updates within a few hours but can take up to 24 hours.</p> 
    <p>Tracking is only available if you paid for a tracked delivery service.</p> 
    <p>Please allow 1 to 2 working days after the expected delivery date for delays.</p>
    <p>If it’s still not arrived after that, fill out the <a href="https://esportsgear.uk/pages/contact?hc=delivery&i=delayed_delivery" target="_blank">contact us</a>.</p>
  `,
  del_tracking_delay: `
    <p>Tracking often updates in batches. It’s normal for it to remain unchanged for a few hours — especially overnight. If it hasn’t updated for 48 hours, <a href="https://esportsgear.uk/pages/contact?hc=delivery&i=other" target="_blank">contact us</a> so we can check with the courier</p>
  `,
  del_why_delayed: `
    <p>Delays can happen due to weather, courier backlogs, routing changes, or peak demand. Tracking updates are sometimes delayed, even while the parcel is still moving.</p>
    <p>If your tracking hasn’t updated for 48 hours or your delivery is past the estimated date, <a href="https://esportsgear.uk/pages/contact?hc=delivery&i=other" target="_blank">get in touch</a>.</p>
    `,
  del_missed: `
    <p>Couriers will usually attempt redelivery on the next working day. You can also use the calling card, email or SMS to rearrange delivery.</p>
  `,
  del_return_to_sender: `
    <p>“Return to Sender” usually means the courier couldn’t complete delivery, the address was incomplete, or the parcel was held too long at a pickup point.</p>
    <p>Once it arrives back with us, we’ll contact you to confirm whether you’d like it re-sent (if possible) or refunded.</p>
  `,
  del_delivered_no_parcel: `
    <p>If tracking shows “Delivered” but you don’t have the parcel, first check safe places, neighbours and anyone else at your address who might have accepted it. Couriers sometimes leave parcels in secure locations.</p>
    <p>If you still can’t find it after checking locally, <a href="https://esportsgear.uk/pages/contact?hc=delivery&i=delivered_no_parcel" target="_blank">contact us</a> and we’ll open an investigation with the courier.</p>
  `,
  del_damaged_redirect: `
    <p>If your item has arrived damaged, this is handled under our <strong>Returns &amp; Warranty</strong> process rather than Delivery.</p>
    <p>Please <a href="https://esportsgear.uk/pages/contact?hc=returns&i=damaged_items" target="_blank">contact us</a> immediately so we can resolve this for you as quickly as possible.</p>
  `,
  ret_return: `
    <p>Review the steps on our <a href="https://esportsgear.uk/pages/returns" target="_blank">Returns</a> page and then complete the <a href="https://esportsgear.uk/pages/contact?hc=returns&f=ret_return" target="_blank">returns form</a> with your details. Once we receive it, we’ll get in touch with instructions on how to send your gear back and what happens next.</p>
  `,
  ret_mind: `
    <p>If you let us know within around 30 calendar days of delivery and the product is unused, “as new” and in its original packaging, you can usually choose a refund, an exchange to another in-stock item or store credit. You’ll just need to pay the return shipping and follow our <a href="https://esportsgear.uk/pages/returns-policy" target="_blank">Returns Policy</a>.</p>
  `,
  del_split: `
    <p>Most orders ship in a single parcel, but if items come from different warehouses you may receive multiple deliveries. We’ll let you know if this happens — there’s no extra cost.</p>
  `,
  del_missing_item: `
    <p>If something is missing, please <a href="https://esportsgear.uk/pages/contact?hc=delivery&i=missing_items" target="_blank">contact us</a> within 48 hours of delivery. Our warehouses use camera and weight checks to confirm what was packed, so we can investigate quickly and resolve it for you.</p>
  `,
};

// 2) Toggle logic (same behaviour/classes as help centre)
function toggleFaq(btn, subreason, forceOpen) {
  const dataKey = subreason || btn.getAttribute('data-subreason') || null;
  if (!dataKey || !trackerFaqContent[dataKey]) return;

  const isOpen = btn.getAttribute('aria-expanded') === 'true';
  const shouldOpen = (typeof forceOpen === 'boolean') ? forceOpen : !isOpen;

  let panel = btn.nextElementSibling;
  if (!panel || !panel.classList.contains('cf-faq-inline')) {
    panel = document.createElement('div');
    panel.className = 'cf-faq-inline';
    btn.insertAdjacentElement('afterend', panel);
  }

  if (!shouldOpen) {
    btn.setAttribute('aria-expanded', 'false');
    btn.classList.remove('is-open');
    panel.classList.remove('is-open');
    return;
  }

  btn.setAttribute('aria-expanded', 'true');
  btn.classList.add('is-open');
  panel.innerHTML = trackerFaqContent[dataKey];
  panel.classList.add('is-open');
}

// 3) Bind all FAQ buttons inside the tracking result
function bindTrackingFaq(root) {
  if (!root) return;

  root.querySelectorAll('.cf-faq-list .cf-reason').forEach(btn => {
    if (btn.dataset.bound === '1') return;
    btn.dataset.bound = '1';

    if (!btn.getAttribute('aria-expanded')) btn.setAttribute('aria-expanded', 'false');

    btn.addEventListener('click', () => {
      const key = btn.getAttribute('data-subreason');
      toggleFaq(btn, key);
    });
  });
}

document.getElementById('cfTrackBtn')?.addEventListener('click', async () => {
  const orderNumber = document.getElementById('cfTrackOrder').value.trim();
  const email = document.getElementById('cfTrackEmail').value.trim().toLowerCase();
  const out = document.getElementById('cfTrackResult');
  const errBox = document.getElementById('cfTrackError');

  if (!orderNumber || !email) {
    errBox.innerHTML = `<p class="cf-track-error">Please enter your order number and email.</p>`;
    out.style.display = 'none';
    return;
  }

  out.style.display = 'block';
  out.innerHTML = `
  <div class="cf-skel">
    <div class="cf-skel-line"></div>
    <div class="cf-skel-line cf-skel-line--short"></div>
    <div class="cf-skel-box"></div>
  </div>
`;

  try {
    const res = await fetch('https://gear-db-proxy.onrender.com/tracking/by-number', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ orderNumber, email })
    });

    const data = await res.json();

    function normaliseEmailAddr(s) {
      return String(s || '').trim().toLowerCase();
    }

    function orderEmailMatchesInput(orderObj, inputEmail) {
      const inEmail = normaliseEmailAddr(inputEmail);

      // Shopify order can expose email in a few different fields depending on how it was created
      const candidates = [
        orderObj?.email,
        orderObj?.contact_email,
        orderObj?.customer?.email
      ].map(normaliseEmailAddr).filter(Boolean);

      if (!inEmail || !candidates.length) return false;

      // exact match against any known email field
      return candidates.includes(inEmail);
    }

    if (!data.ok) {
      errBox.innerHTML = `<p class="cf-track-error">Order not found. Please check your order number and email.</p>`;
      out.style.display = 'none';
      return;
    }
    const order = data.order || {};
    errBox.innerHTML = '';
    // Hard stop if email doesn't match the order email
    if (!orderEmailMatchesInput(order, email)) {
      errBox.innerHTML = `<p class="cf-track-error">Order not found. Please check your order number and email.</p>`;
      out.style.display = 'none';
      return;
    }
    console.log("DEBUG LINE ITEMS:", order.line_items);
    const fulfillments = Array.isArray(data.fulfillments) ? data.fulfillments : [];
    const f = fulfillments[0] || null;

// ───────────────────────────────────────────
// Cancelled order (show summary + items only)
// ───────────────────────────────────────────
if (order.cancelled_at) {
  out.innerHTML = `
  <hr/>
    <p class="cf-order-number">${order.name || '—'}</p>
    <div class="cf-order-summary">
      <div class="cf-summary-grid">
        <div class="cf-summary-item">
          <span class="cf-summary-label">Order Status</span>
          <span class="cf-summary-value">
            <span class="cf-pill cf-pill--bad">Cancelled</span>
          </span>
        </div>

        <div class="cf-summary-item">
          <span class="cf-summary-label">Cancelled At</span>
          <span class="cf-summary-value">${formatDateTime(order.cancelled_at) || '—'}</span>
        </div>
      </div>
    </div>

    ${buildItemBreakdown(order, fulfillments)}
  `;
  return;
}

    // ───────────────────────────────────────────
    // Helpers
    // ───────────────────────────────────────────

    function typeNextMessage() {
      const el = document.querySelector('.cf-next-msg');
      if (!el) return;

      const full = el.textContent.trim();
      if (!full) return;

      el.classList.add('cf-typing');
      el.textContent = '';

      let i = 0;
      const SPEED = 35; // ms per character (tweak 30–50)

      const tick = () => {
        i++;
        el.textContent = full.slice(0, i);

        if (i < full.length) {
          setTimeout(tick, SPEED);
        } else {
          el.classList.remove('cf-typing');
        }
      };

      setTimeout(tick, SPEED);
    }

    function scrollToOrderNumber() {
      requestAnimationFrame(() => {
        const el = document.querySelector('.cf-order-number');
        if (!el) return;

        const NAV_OFFSET = 115; // adjust once if your header height changes

        const y =
          el.getBoundingClientRect().top +
          window.pageYOffset -
          NAV_OFFSET;

        window.scrollTo({
          top: y,
          behavior: 'smooth'
        });
      });
    }

    const financial = (order.financial_status || '').toLowerCase();
    const fulfillmentStatus = (order.fulfillment_status || '').toLowerCase();
    const shippingLine = (order.shipping_lines && order.shipping_lines[0]) || null;

    function paymentStatusLabel(status) {
      switch (status) {
        case 'paid':
        case 'pending':
        case 'authorized':
          return { text: 'Paid', pillClass: 'cf-pill--ok' };

        case 'partially_refunded':
          return { text: 'Partially Refunded', pillClass: 'cf-pill--warn' };

        case 'refunded':
        case 'voided':
        case 'expired':
          return { text: 'Cancelled', pillClass: 'cf-pill--bad' };

        default:
          return { text: 'Paid', pillClass: 'cf-pill--ok' };
      }
    }

    function fulfillmentStatusLabel(status) {
      switch (status) {
        case 'unfulfilled':
          return { text: 'Not shipped yet', pillClass: 'cf-pill--warn' };

        case 'partial':
          return { text: 'Partially shipped', pillClass: 'cf-pill--warn' };

        case 'fulfilled':
          return { text: 'Shipped', pillClass: 'cf-pill--ok' };

        case 'restocked':
          return { text: 'N/A', pillClass: 'cf-pill--neutral' };

        default:
          return { text: 'Not shipped yet', pillClass: 'cf-pill--warn' };
      }
    }

    function getSupportCTA({ f, deliveredAt }) {
      if (!f) return { text: 'Contact support about dispatch', type: 'dispatch' };
      if (!deliveredAt) return { text: 'Problem with delivery?', type: 'delivery' };
      return { text: 'Issue after delivery?', type: 'post' };
    }
    
    function getHelpState(orderObj, fulfilmentArr = []) {
      const fulfils = Array.isArray(fulfilmentArr) ? fulfilmentArr : [];
      const hasShipments = fulfils.length > 0;

      // “Pending items” = not fully fulfilled yet (Shopify uses fulfillable_quantity)
      const items = Array.isArray(orderObj?.line_items) ? orderObj.line_items : [];
      const hasPendingItems = items.some(li => (li.fulfillable_quantity || 0) > 0);

      const allDelivered = hasShipments && fulfils.every(f => (f?.shipment_status || '').toLowerCase() === 'delivered');

      // Split shipment if multiple parcels OR partially shipped (some shipped + some still pending)
      const isSplit = fulfils.length > 1 || (hasShipments && hasPendingItems);

      if (!hasShipments) return { key: 'not_shipped', isSplit: false };
      if (isSplit) {
        // Split overrides the normal shipped/delivered messaging because the guidance differs
        // (You can still use allDelivered inside the split block if you want later)
        return { key: 'split', isSplit: true, allDelivered };
      }
      if (allDelivered) return { key: 'delivered', isSplit: false };

      return { key: 'shipped', isSplit: false };
    }

function buildHelpSection(orderObj, fulfilmentArr = []) {
  const fulfils = Array.isArray(fulfilmentArr) ? fulfilmentArr : [];
  const hasShipments = fulfils.length > 0;

  const items = Array.isArray(orderObj?.line_items) ? orderObj.line_items : [];
  const hasPendingItems = items.some(li => (li.fulfillable_quantity || 0) > 0);

  const allDelivered =
    hasShipments &&
    fulfils.length > 0 &&
    fulfils.every(f => (f?.shipment_status || '').toLowerCase() === 'delivered');

  // Split shipment = multiple fulfilments OR partially shipped (some shipped + some pending)
  const isSplit = fulfils.length > 1 || (hasShipments && hasPendingItems);

  // state priority: split overrides, then delivered, then shipped, else not shipped
  let state = 'not_shipped';
  if (isSplit) state = 'split';
  else if (allDelivered) state = 'delivered';
  else if (hasShipments) state = 'shipped';

  // --- FAQ blocks (same markup/classes as help centre buttons) ---
function faqButton({ subreason, subject, text }) {
  return `
    <button type="button" class="cf-reason"
            data-subreason="${subreason}"
            data-subject="${subject}"
            aria-expanded="false">
      <span class="cf-faq-question-text">${text}</span>
      <span class="plus-button plus-button--large"></span>
    </button>
    <div class="cf-faq-inline"></div>
  `;
}

  // Use your existing questions by reusing the same IDs/text
  let faqHtml = '';

  if (state === 'not_shipped') {
    faqHtml = `
      <div class="cf-subgroup">
        ${faqButton({ subreason:'orders_unfulfilled', subject:"Orders: My order hasn't been fulfilled yet", text:"My order hasn't been fulfilled yet, why not?" })}
        ${faqButton({ subreason:'orders_change', subject:"Orders: Can I change my order?", text:"Can I change my order?" })}
        ${faqButton({ subreason:'orders_cancel', subject:"Orders: Can I cancel my order?", text:"Can I cancel my order?" })}
        ${faqButton({ subreason:'del_change_address', subject:"Delivery: Can I change my delivery address?", text:"Can I change my delivery address after ordering?" })}
      </div>
    `;
  } else if (state === 'shipped') {
    faqHtml = `
      <div class="cf-subgroup">
        ${faqButton({ subreason:'del_where', subject:"Delivery: Where's my order?", text:"Where's my order?" })}
        ${faqButton({ subreason:'del_tracking_delay', subject:"Delivery: Tracking not updating", text:"Why isn't my tracking information showing yet?" })}
        ${faqButton({ subreason:'del_why_delayed', subject:"Delivery: Why is my delivery delayed?", text:"Why was my delivery delayed?" })}
        ${faqButton({ subreason:'del_missed', subject:"Delivery: Missed delivery", text:"I missed my delivery, what are my options?" })}
        ${faqButton({ subreason:'del_return_to_sender', subject:"Delivery: My parcel is being returned to sender", text:"My tracking says “Return to sender”" })}
      </div>
    `;
  } else if (state === 'delivered') {
    faqHtml = `
      <div class="cf-subgroup">
        ${faqButton({ subreason:'del_delivered_no_parcel', subject:"Delivery: Tracking says delivered but I don’t have it", text:"Tracking says delivered but I don’t have my order" })}
        ${faqButton({ subreason:'del_damaged_redirect', subject:"Delivery: Damaged item redirection", text:"My item is damaged – what should I do?" })}
        ${faqButton({ subreason:'ret_return', subject:"Returns: How do I arrange a return?", text:"How do I arrange a return?" })}
        ${faqButton({ subreason:'ret_mind', subject:"Returns: I've changed my mind", text:"I've changed my mind, what are my options?" })}
      </div>
    `;
  } else {
    // split
    faqHtml = `
      <div class="cf-subgroup">
        ${faqButton({ subreason:'del_split', subject:"Delivery: Split shipments", text:"Will my items all come in the same delivery?" })}
        ${faqButton({ subreason:'del_missing_item', subject:"Delivery: Missing item", text:"An item is missing from my order. Where is it?" })}
        ${faqButton({ subreason:'del_tracking_delay', subject:"Delivery: Tracking not updating", text:"Why isn't my tracking information showing yet?" })}
        ${faqButton({ subreason:'del_where', subject:"Delivery: Where's my order?", text:"Where's my order?" })}
      </div>
    `;
  }

  const title =
    state === 'split' ? 'Split shipment help' :
    state === 'delivered' ? 'Delivered help' :
    state === 'shipped' ? 'Delivery help' :
    'Order help';

    const faqHeading = `<p class="cf-order-summary-title">FAQs</p>`;

    return `
      <div class="cf-track-container">
        <div class="contact-form--wizard">
          <div class="cf-subquestions">
            ${faqHeading}
            <div class="cf-faq-list">
              ${faqHtml}
            </div>
          </div>
        </div>
      </div>
    `;
}
    
    function formatDateTime(dt) {
      if (!dt) return '';
      const d = new Date(dt);
      return d.toLocaleString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    }

    function formatDuration(from, to) {
      if (!from || !to) return '';
      const start = new Date(from).getTime();
      const end = new Date(to).getTime();
      if (!start || !end || end <= start) return '';
      const diffMs = end - start;

      const mins = Math.floor(diffMs / 60000);
      const hours = Math.floor(mins / 60);
      const days = Math.floor(hours / 24);

      if (days > 0) {
        const remHours = hours % 24;
        if (remHours > 0) return `${days}d ${remHours}h`;
        return `${days}d`;
      }
      if (hours > 0) {
        const remMins = mins % 60;
        if (remMins > 0) return `${hours}h ${remMins}m`;
        return `${hours}h`;
      }
      if (mins > 0) return `${mins}m`;
      return '< 1m';
    }

    function toISODate(d) {
  return d.toISOString().slice(0, 10);
}

// Keep this list updated (UK bank holidays) — configurable on purpose.
const UK_BANK_HOLIDAYS = new Set([
  // '2026-01-01',
  // '2026-04-03',
  // '2026-04-06',
  // '2026-05-04',
  // '2026-05-25',
  // '2026-08-31',
  // '2026-12-25',
  // '2026-12-28',
]);

function isBusinessDay(d) {
  const day = d.getDay(); // 0 Sun .. 6 Sat
  if (day === 0 || day === 6) return false;
  if (UK_BANK_HOLIDAYS.has(toISODate(d))) return false;
  return true;
}

function addBusinessDays(startDate, businessDays) {
  if (!startDate || businessDays <= 0) return null;
  const d = new Date(startDate);
  let remaining = businessDays;

  // start counting from the next day
  d.setHours(12, 0, 0, 0);

  while (remaining > 0) {
    d.setDate(d.getDate() + 1);
    if (isBusinessDay(d)) remaining--;
  }
  return d;
}

function isUntrackedShippingMethod(title = '') {
  const t = String(title || '').toLowerCase();

  // edit this list to match your actual shipping titles
  const UNTRACKED_MATCH = [
    'untracked',
    'non-tracked',
    'non tracked',
    'not tracked'
  ];

  return UNTRACKED_MATCH.some(x => t.includes(x));
}

// Extract "2-3 Working Days" or "2–3" etc from the delivery service text.
function parseWorkingDayRange(serviceTitle = '') {
  const raw = String(serviceTitle || '').trim();
  const s = raw.toLowerCase();

  // EXPRESS: next working day (business day) — ignore weekends + holidays
  if (s.includes('express')) {
    return { min: 1, max: 1, type: 'business_days' };
  }

  // Anything with "(2-3 Working Days)" etc.
  // supports "-" or "–"
  const range = s.match(/(\d+)\s*(?:-|–)\s*(\d+)\s*working\s*days?/i);
  if (range) return { min: parseInt(range[1], 10), max: parseInt(range[2], 10), type: 'business_days' };

  // Single day fallback: "(2 Working Days)"
  const single = s.match(/(\d+)\s*working\s*days?/i);
  if (single) {
    const n = parseInt(single[1], 10);
    return { min: n, max: n, type: 'business_days' };
  }

  return null;
}

function ordinal(n) {
  const v = n % 100;
  if (v >= 11 && v <= 13) return `${n}th`;
  switch (n % 10) {
    case 1: return `${n}st`;
    case 2: return `${n}nd`;
    case 3: return `${n}rd`;
    default: return `${n}th`;
  }
}

function formatEtaRangeShort(etaMin, etaMax) {
  if (!etaMin || !etaMax) return '—';

  const a = new Date(etaMin);
  const b = new Date(etaMax);

  const dayA = a.getDate();
  const dayB = b.getDate();

  const monthA = a.toLocaleString('en-GB', { month: 'short' });
  const monthB = b.toLocaleString('en-GB', { month: 'short' });

  // Same month -> "16 - 19th Jan"
  if (a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth()) {
    return `${dayA} - ${ordinal(dayB)} ${monthB}`;
  }

  // Different month -> "30th Jan - 2nd Feb"
  return `${ordinal(dayA)} ${monthA} - ${ordinal(dayB)} ${monthB}`;
}

function calcDeliveryETA({ createdAt, dispatchAt, deliveredAt, shippingMethod }) {
  // DO NOT return null when delivered — we still want to show the ETA range
  const r = parseWorkingDayRange(shippingMethod);
  if (!r) return null;

  // If shipped, ETA should be based from dispatch; otherwise from order placed.
  const base = createdAt;
  if (!base) return null;

  const etaMin = addBusinessDays(base, r.min);
  const etaMax = addBusinessDays(base, r.max);

  return { etaMin, etaMax, base };
}

function getWhatHappensNextMessage(fulfilmentArr = [], shippingMethod = '', eta = null) {
  const fulfils = Array.isArray(fulfilmentArr) ? fulfilmentArr : [];
  const hasShipments = fulfils.length > 0;

  const allDelivered =
    hasShipments &&
    fulfils.every(f => (f?.shipment_status || '').toLowerCase() === 'delivered');

  // Split = more than 1 fulfilment OR partially shipped (pending items still exist)
  // (We only have fulfilments here, so we’ll use fulfilment count for split in this message.)
  const isSplit = fulfils.length > 1;

  // 1) Delivered
  if (allDelivered) return "Delivery is complete";

  // 2) ETA passed + not delivered => hide
  if (eta && !shouldShowEta(eta)) return null;

  const isUntracked = isUntrackedShippingMethod(shippingMethod);

  const hasAnyTracking =
    hasShipments &&
    fulfils.some(f =>
      (f?.tracking?.number && String(f.tracking.number).trim()) ||
      (f?.tracking?.url && String(f.tracking.url).trim())
    );

  // 3) Untracked shipping method:
  // show ONLY before fulfilment, hide once fulfilled
  if (isUntracked) {
    if (!hasShipments) return "Your order will update once dispatched";
    return null;
  }

  // 4) Fulfilled but no tracking => hide
  if (hasShipments && !hasAnyTracking) return null;

  // 5) Normal flow
  if (!hasShipments) return "Your order will update once dispatched";

  // shipped, tracked:
  // split-safe wording
  return isSplit
    ? "Your parcels are with the courier and on their way to you"
    : "Your parcel is with the courier and on it's way to you";
}


function renderWhatHappensNext(fulfilmentArr = [], shippingMethod = '', eta = null) {
  const msg = getWhatHappensNextMessage(fulfilmentArr, shippingMethod, eta);
  if (!msg) return '';

  return `
    <div class="cf-next">
      <div class="cf-next-msg">${msg}</div>
    </div>
  `;
}

function shouldShowEta(eta) {
  if (!eta?.etaMax) return false;

  const max = new Date(eta.etaMax);
  if (Number.isNaN(max.getTime())) return false;

  // Treat ETA as valid through the end of the etaMax day (local time)
  max.setHours(23, 59, 59, 999);

  return max.getTime() >= Date.now();
}

    // ── NEW: order item breakdown ─────────────────
    function buildItemBreakdown(orderObj, fulfilmentArr = []) {
      const items = Array.isArray(orderObj.line_items) ? orderObj.line_items : [];
      if (!items.length) return '';

      // shipped qty comes ONLY from fulfilments (source of truth)
      const shippedByLineId = new Map();

      if (Array.isArray(fulfilmentArr) && fulfilmentArr.length) {
        fulfilmentArr.forEach(ful => {
          const fulItems = Array.isArray(ful.line_items) ? ful.line_items : [];
          fulItems.forEach(li => {
            // Fulfillment line item id should match order line_item.id
            const lineId = li.id ?? li.line_item_id;
            if (lineId == null) return;

            const prev = shippedByLineId.get(lineId) || 0;
            shippedByLineId.set(lineId, prev + (li.quantity || 0));
          });
        });
      }

      const rows = items.map(li => {
        const qty = li.quantity || 0;
        const lineId = li.id;

        let shippedQty = shippedByLineId.get(lineId) || 0;
        shippedQty = Math.min(shippedQty, qty);

        let status = 'Not shipped yet';
        let badge = 'cf-pill--warn';

        if (shippedQty >= qty && qty > 0) {
          status = 'Shipped';
          badge = 'cf-pill--ok';
        } else if (shippedQty > 0 && shippedQty < qty) {
          status = 'Partially shipped';
          badge = 'cf-pill--warn';
        }

      return `
        <tr data-line-id="${lineId}">
          <td class="cf-items-name">${li.name || li.title || 'Item'}</td>
          <td>${qty}</td>
          <td><span class="cf-pill ${badge}">${status}</span></td>
        </tr>
        `;
      }).join('');

      return `
        <div class="cf-items">
          <div class="cf-items-scroll">
            <table class="cf-items-table">
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Qty</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                ${rows}
              </tbody>
            </table>
          </div>
        </div>
      `;
    }

    // ── NEW: multi-fulfilment cards ───────────────
    function shipmentStatusLabel(ful) {
      const status = (ful?.shipment_status || '').toLowerCase();

      // IMPORTANT: in your business logic, if a fulfillment exists, it's shipped.
      if (!status) {
        return { text: 'Shipped', pillClass: 'cf-pill--ok' };
      }

      switch (status) {
        case 'in_transit':       return { text: 'Shipped', pillClass: 'cf-pill--ok' };
        case 'out_for_delivery': return { text: 'Out for Delivery', pillClass: 'cf-pill--ok' };
        case 'delivered':        return { text: 'Delivered', pillClass: 'cf-pill--ok' };
        case 'label_printed':    return { text: 'Label Printed', pillClass: 'cf-pill--neutral' };
        default:                 return { text: 'Shipped', pillClass: 'cf-pill--ok' }; // never "Created" for real fulfilments
      }
    }

function buildFulfilmentCards(orderObj, fulfilmentArr, shippingMethod) {
const orderIsUntracked = isUntrackedShippingMethod(shippingMethod);

const COURIER_LOGOS = {
  dpd: "https://cdn.shopify.com/s/files/1/0102/8426/9615/files/dpd.png?v=1736497615",
  fedex: "https://cdn.shopify.com/s/files/1/0102/8426/9615/files/fedex_express_1.png?v=1736497005",
  royalmail: "https://cdn.shopify.com/s/files/1/0102/8426/9615/files/royalmail.png?v=1649364327",
  evri: "https://cdn.shopify.com/s/files/1/0102/8426/9615/files/evri.png?v=1659013941",
  dhl: "https://cdn.shopify.com/s/files/1/0102/8426/9615/files/dhl_a3de13ad-e1e4-47e9-84d1-775b762badc0.png?v=1736497505",
  ups: "https://cdn.shopify.com/s/files/1/0102/8426/9615/files/ups.png?v=1736497505",
};

function getCourierKey(name = "") {
  const s = String(name || "").toLowerCase();
  if (s.includes("dpd")) return "dpd";
  if (s.includes("fedex")) return "fedex";
  if (s.includes("royal")) return "royalmail";
  if (s.includes("evri") || s.includes("hermes")) return "evri";
  if (s.includes("dhl")) return "dhl";
  if (s.includes("ups")) return "ups";
  return null;
}

function renderCourierDisplay(courierName = "") {
  const key = getCourierKey(courierName);
  const url = key ? COURIER_LOGOS[key] : null;
  if (!url) return `<span class="cf-courier-text">${courierName || "N/A"}</span>`;

  const alt =
    key === "royalmail" ? "Royal Mail" :
    key.toUpperCase();

  return `
    <span class="cf-courier-badge" aria-label="${alt}">
      <img class="cf-courier-logo" src="${url}" alt="${alt}">
    </span>
  `;
}

function untrackedNote() {
  return `
    <p class="cf-untracked-note">
      This delivery service is untracked, so live tracking updates aren’t available.
    </p>
  `;
}

function shipmentTimeline(ful) {
  const ss = (ful.shipment_status || '').toLowerCase();

  const inTransit = ss === 'in_transit';
  const outForDelivery = ss === 'out_for_delivery';
  const delivered = ss === 'delivered';

  // Step states:
  // 1) Order received = always true (we have the order)
  // 2) Dispatched = fulfillment exists (this timeline is only rendered for real fulfilments)
  // 3) On way to you = any carrier movement state (incl. out_for_delivery) OR delivered
  const onWay = inTransit || outForDelivery || delivered;

  const forceAllActive = delivered;

  // Progress fill for 4 steps:
  // 0 = received, 1/3 = dispatched, 2/3 = on way, 1 = delivered
  let progressFrac = 0;
  if (delivered) progressFrac = 1;
  else if (onWay) progressFrac = 2 / 3;
  else progressFrac = 1 / 3; // dispatched but no scans yet

  return `
    <div class="cf-ship-progress cf-ship-progress--4">
      <div class="cf-ship-line"></div>
      <div class="cf-ship-fill" style="--p:${progressFrac};"></div>

      <div class="cf-ship-step cf-active">
        <div class="cf-ship-dot"></div>
        <div class="cf-ship-label">Order received</div>
        <div class="cf-ship-ts">${orderObj?.created_at ? formatDateTime(orderObj.created_at) : ''}</div>
      </div>

      <div class="cf-ship-step cf-active">
        <div class="cf-ship-dot"></div>
        <div class="cf-ship-label">Dispatched</div>
        <div class="cf-ship-ts">${ful.created_at ? formatDateTime(ful.created_at) : ''}</div>
      </div>

      <div class="cf-ship-step ${(onWay || forceAllActive) ? 'cf-active' : ''}">
        <div class="cf-ship-dot"></div>
        <div class="cf-ship-label">On the way</div>
      </div>

      <div class="cf-ship-step ${(delivered || forceAllActive) ? 'cf-active' : ''}">
        <div class="cf-ship-dot"></div>
        <div class="cf-ship-label">Delivered</div>
        <div class="cf-ship-ts">${delivered ? formatDateTime(ful.updated_at) : ''}</div>
      </div>
    </div>
  `;
}

  let cards = '';
  const realCount = Array.isArray(fulfilmentArr) ? fulfilmentArr.length : 0;
  const showParcelLabel = realCount > 1;

  // REAL SHIPMENTS
  if (fulfilmentArr?.length) {
    cards += fulfilmentArr.map((ful, idx) => {
      const stat = shipmentStatusLabel(ful);
      const courierName = ful.tracking?.company || 'N/A';
      const trackingNoRaw = ful.tracking?.number;
      const trackingUrl = ful.tracking?.url || null;
      const hasTracking = !!(trackingNoRaw || trackingUrl);
      const hideProgress = orderIsUntracked && !hasTracking;

      // If we fulfilled but have no tracking (by design), show friendly text
      const trackingNo = trackingNoRaw ? trackingNoRaw : 'Not available yet';

      const shipmentLineIds = (ful.line_items || [])
        .map(li => li.id ?? li.line_item_id)
        .filter(Boolean)
        .join(',');

        const items = (ful.line_items || [])
        .map(li => `<li>${li.title} <span class="cf-ful-item-qty">×${li.quantity}</span></li>`)
        .join('');

      const courierStr = (courierName || '').toLowerCase();
      let courierClass = '';

      if (courierStr.includes('dpd')) courierClass = 'cf-courier-dpd';
      else if (courierStr.includes('evri') || courierStr.includes('hermes')) courierClass = 'cf-courier-evri';
      else if (courierStr.includes('royal')) courierClass = 'cf-courier-rm';
      else if (courierStr.includes('fedex')) courierClass = 'cf-courier-fedex';
      else if (courierStr.includes('dhl')) courierClass = 'cf-courier-dhl';
      else if (courierStr.includes('ups')) courierClass = 'cf-courier-ups';

      return `
        <div class="cf-fulfilment-card ${courierClass}" data-lines="${shipmentLineIds}">
          <div class="cf-ful-header">
            <span class="cf-ful-title">${showParcelLabel ? `Parcel ${idx + 1}` : ''}</span>
            <span class="cf-pill ${stat.pillClass}">${stat.text}</span>
          </div>

          <div class="cf-ful-meta">
            <div>
              <span class="cf-summary-label">Courier</span>
              <span class="cf-summary-value">${renderCourierDisplay(courierName)}</span>
            </div>
            <div><span class="cf-summary-label">Dispatched</span><span class="cf-summary-value">${formatDateTime(ful.created_at)}</span></div>
            <div><span class="cf-summary-label">Last Update</span><span class="cf-summary-value">${formatDateTime(ful.updated_at)}</span></div>
            <div>
              <span class="cf-summary-label">Tracking</span>
              <span class="cf-summary-value">
                ${trackingNo}
                ${trackingUrl ? `<a href="${trackingUrl}" target="_blank" class="cf-track-link">View</a>` : ''}
              </span>
            </div>
          </div>

          ${items ? `<ul class="cf-ful-items">${items}</ul>` : ''}

          ${hideProgress ? untrackedNote() : shipmentTimeline(ful)}
        </div>
      `;
    }).join('');
  }

  // SYNTHETIC “PENDING SHIPMENT”
  const unfulfilled = (orderObj.line_items || []).filter(li => li.fulfillable_quantity > 0);

  if (unfulfilled.length > 0) {
    const pendingItems = unfulfilled
      .map(li => `<li>${li.title} <span class="cf-ful-item-qty">×${li.fulfillable_quantity}</span></li>`)
      .join('');

    cards += `
      <div class="cf-fulfilment-card">
        <div class="cf-ful-header">
          <span class="cf-ful-title">Pending Shipment</span>
          <span class="cf-pill cf-pill--warn">Awaiting Dispatch</span>
        </div>

        <ul class="cf-ful-items">${pendingItems}</ul>

      ${orderIsUntracked ? untrackedNote() : `
        <div class="cf-ship-progress cf-ship-progress--1">
          <div class="cf-ship-line"></div>
          <div class="cf-ship-fill" style="--p:0;"></div>

          <div class="cf-ship-step cf-active">
            <div class="cf-ship-dot"></div>
            <div class="cf-ship-label">Not yet shipped</div>
          </div>
        </div>
      `}
      </div>
      `;
      }

  return `
    <div class="cf-fulfilments">
      <div class="cf-fulfilments-list">${cards}</div>
    </div>
  `;
}

    const pay = paymentStatusLabel(financial);
    const full = fulfillmentStatusLabel(fulfillmentStatus);

    function normaliseShippingMethod(title = '') {
      let t = String(title).trim();

      // Remove “UK Mainland Only” (with or without asterisks)
      t = t.replace(/\*?\s*UK Mainland Only\s*\*?/gi, '').trim();

      // Optional: clean up leftover double spaces or dangling dashes
      t = t.replace(/\s{2,}/g, ' ');
      t = t.replace(/\s+-\s*$/g, '');

      return t || '—';
      }   

    const shippingMethod = normaliseShippingMethod(shippingLine?.title);
    const createdAt = order.created_at || order.processed_at || null;
    const dispatchAt = f?.created_at || null;
    const deliveredAt = (f && f.shipment_status === 'delivered' && f.updated_at) ? f.updated_at : null;
    const eta = calcDeliveryETA({ createdAt, dispatchAt, deliveredAt, shippingMethod });
    const supportCTA = getSupportCTA({ f, deliveredAt });

    const dispatchDelay = formatDuration(createdAt, dispatchAt);
    const deliveryDuration = formatDuration(dispatchAt, deliveredAt);

    // Timeline progress (0, 25, 50, 75, 100)
    const shipped = !!f;
    const inTransit = f?.shipment_status === 'in_transit';
    const outForDelivery = f?.shipment_status === 'out_for_delivery';
    const delivered = f?.shipment_status === 'delivered';

    let progress = 0;
    if (shipped) progress = 25;
    if (inTransit) progress = 50;
    if (outForDelivery) progress = 75;
    if (delivered) progress = 100;

    // ───────────────────────────────────────────
    // Render HTML
    // ───────────────────────────────────────────
    // No fulfillment yet → simple 2-step timeline 
    if (!f) {
      out.innerHTML = `
        <hr/>
        <p class="cf-order-number">${order.name}</p>

      ${renderWhatHappensNext(fulfillments, shippingMethod, eta)}
      ${shouldShowEta(eta) ? `
        <div class="cf-eta-banner">
          <div class="cf-eta-title">Estimated delivery</div>
          <div class="cf-eta-range">${formatEtaRangeShort(eta.etaMin, eta.etaMax)}</div>
          <div class="cf-eta-sub">Based on your selected Delivery Service</div>
        </div>
      ` : ''}
        <hr class="hidden-phone"/>
        <div class="cf-order-summary">
          <div class="cf-summary-grid">

            <div class="cf-summary-item">
              <span class="cf-summary-label">Order Placed</span>
              <span class="cf-summary-value">${formatDateTime(createdAt) || '—'}</span>
            </div>

            <div class="cf-summary-item">
              <span class="cf-summary-label">Order status</span>
              <span class="cf-summary-value">
                <span class="cf-pill ${full.pillClass}">${full.text}</span>
              </span>
            </div>

            <div class="cf-summary-item">
              <span class="cf-summary-label">Delivery Service</span>
              <span class="cf-summary-value">${shippingMethod}</span>
            </div>

          </div>
        </div>
        ${buildHelpSection(order, fulfillments)}
      `;
      bindTrackingFaq(out);
      scrollToOrderNumber();
      typeNextMessage();
      return;
    }

    // Fulfillment exists → full tracking view with shipments + items
    out.innerHTML = `
    <hr class="hidden-phone"/>
      <p class="cf-order-number">${order.name}</p>

    ${renderWhatHappensNext(fulfillments, shippingMethod, eta)}
    ${shouldShowEta(eta) ? `
      <div class="cf-eta-banner">
        <div class="cf-eta-title">Estimated delivery</div>
        <div class="cf-eta-range">${formatEtaRangeShort(eta.etaMin, eta.etaMax)}</div>
        <div class="cf-eta-sub">Based on your selected Delivery Service</div>
      </div>
    ` : ''}

    <hr class="hidden-phone"/>
    <div class="cf-order-summary">
      <div class="cf-summary-grid">

        <div class="cf-summary-item">
          <span class="cf-summary-label">Order Placed</span>
          <span class="cf-summary-value">${formatDateTime(createdAt) || '—'}</span>
        </div>

        <div class="cf-summary-item">
          <span class="cf-summary-label">Order status</span>
          <span class="cf-summary-value">
            <span class="cf-pill ${full.pillClass}">${full.text}</span>
          </span>
        </div>

        <div class="cf-summary-item">
          <span class="cf-summary-label">Delivery Service</span>
          <span class="cf-summary-value">${shippingMethod}</span>
        </div>

      </div>
    </div>

    ${buildFulfilmentCards(order, fulfillments, shippingMethod)}
    ${buildHelpSection(order, fulfillments)}
    `;

    bindTrackingFaq(out);
    scrollToOrderNumber();
    typeNextMessage();

    // Shipment → item highlight wiring
    document.querySelectorAll('.cf-fulfilment-card[data-lines]').forEach(card => {
      card.addEventListener('mouseenter', () => {
        const ids = (card.dataset.lines || '').split(',').filter(Boolean);
        document.querySelectorAll('.cf-items-table tr[data-line-id]').forEach(row => {
          row.classList.toggle('cf-item-highlight', ids.includes(row.dataset.lineId));
        });
      });

      card.addEventListener('mouseleave', () => {
        document.querySelectorAll('.cf-items-table tr.cf-item-highlight')
          .forEach(r => r.classList.remove('cf-item-highlight'));
      });
    });

  } catch (err) {
    console.error(err);
    out.innerHTML = `<p class="cf-track-error">Something went wrong. Please try again.</p>`;
  }
});